
import { singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/AsyncBuilder.js";
import { Async_valueOrRaise } from "./Receivers.js";
import { addPrefix, Async_fetchWithDecoder } from "../CommunicationV2.js";
import { HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.6.0/Types.fs.js";
import { equals, Exception } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { UserRoleAssignmentDto_$reflection, RoleDefinition_$reflection } from "../Shared/Roles.js";
import { option_type, list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { bind } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function Async_getAssignedRole(userId) {
    return singleton.Delay(() => singleton.Bind(Async_valueOrRaise(Async_fetchWithDecoder(addPrefix("/api/roles"), "", new HttpMethod(0, []), "application/json", (response) => singleton.Delay(() => {
        let resp;
        const matchValue = response.content;
        switch (matchValue.tag) {
            case 0: {
                throw new Exception("not implemented - text response");
                break;
            }
            case 1: {
                throw new Exception("not implemented - blob response");
                break;
            }
            case 3: {
                resp = matchValue.fields[0];
                break;
            }
            default:
                resp = (new Uint8Array(matchValue.fields[0]));
        }
        return singleton.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), list_type(RoleDefinition_$reflection())));
    }))), (_arg) => singleton.Bind(Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/roles/users/", ...userId)), "", new HttpMethod(0, []), "application/json", (response_1) => singleton.Delay(() => {
        let resp_1;
        const matchValue_1 = response_1.content;
        switch (matchValue_1.tag) {
            case 0: {
                throw new Exception("not implemented - text response");
                break;
            }
            case 1: {
                throw new Exception("not implemented - blob response");
                break;
            }
            case 3: {
                resp_1 = matchValue_1.fields[0];
                break;
            }
            default:
                resp_1 = (new Uint8Array(matchValue_1.fields[0]));
        }
        return singleton.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp_1), option_type(UserRoleAssignmentDto_$reflection())));
    }))), (_arg_1) => singleton.Return(bind((assignment_1) => tryFind((role) => equals(role.Id, assignment_1.RoleId), _arg), _arg_1)))));
}

